export default "__VITE_ASSET__IpZTgv6Q__"